import React, { useState } from 'react';
import { useAuth } from '../store/hooks/useAuth';
import Sidebar from './Sidebar';
import Header from './Header';

function Layout({ children, headerProps = {} }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const { user } = useAuth();

  return (
    <div className="h-screen flex overflow-hidden bg-slate-50/95">
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
        isMobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />

      {/* Mobile overlay */}
      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-30 lg:hidden"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden">
        <Header
          showUser
          userName={user?.name || 'Admin'}
          onMobileMenuClick={() => setMobileSidebarOpen(true)}
          showMobileMenuButton
          {...headerProps}
        />

        {/* Page content - scrollable */}
        <main className="flex-1 min-h-0 overflow-y-auto p-6 lg:p-8 overscroll-contain bg-slate-50/80">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
